<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            Configuração de Código Contábil
          </h4>
          <div class="row">
            <div class="col-md-12 pr-md-1 text-left">
              <label class="control-label">Rubrica</label>
              <select
                class="form-control"
                v-model="model.rubrica"
                placeholder="Selecione uma Rubrica"
              >
                <option value="" disabled>Selecione uma Rubrica</option>
                <option value="Alterdata">Alterdata</option>
                <option value="Dominio">Dominio</option>
                <option value="Omie">Omie</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 pr-md-1 text-left">
              <base-input
                label="Falta em Horas"
                type="tel"
                v-mask="'#####'"
                placeholder="Falta em Horas"
                v-model="model.faltasHoras"
              >
              </base-input>
            </div>
            <div class="col-md-6 pr-md-1 text-left">
              <base-input
                label="Falta em Dias"
                type="tel"
                v-mask="'#####'"
                placeholder="Falta em Dias"
                v-model="model.faltasDias"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 pr-md-1 text-left">
              <base-input
                label="Atraso em Horas"
                type="tel"
                v-mask="'#####'"
                placeholder="Atraso em Horas"
                v-model="model.atrasoHoras"
              >
              </base-input>
            </div>
            <div class="col-md-6 pr-md-1 text-left">
              <base-input
                label="Ad Noturno em Horas"
                type="tel"
                v-mask="'#####'"
                placeholder="Ad Noturno em Horas"
                v-model="model.adNoturnoHoras"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 pr-md-1 text-left">
              <base-input
                label="Hora Extra 50%"
                type="tel"
                v-mask="'#####'"
                placeholder="Hora Extra 50%"
                v-model="model.horaExtra50"
              >
              </base-input>
            </div>
            <div class="col-md-6 pr-md-1 text-left">
              <base-input
                label="Hora Extra 100%"
                type="tel"
                v-mask="'#####'"
                placeholder="Hora Extra 100%"
                v-model="model.horaExtra100"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 pr-md-1 text-left">
              <base-input
                label="Código da Empresa"
                type="tel"
                v-mask="'##########'"
                placeholder="Opcional"
                v-model="model.codEmpresa"
              >
              </base-input>
            </div>
          </div>
          <template slot="footer">
            <base-button type="success" fill @click="cadastrarRubrica()"
              >Cadastrar</base-button
            >
          </template>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import users from "../../pages/Tables/users.js";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "../../pages/Notifications/NotificationHorarioLimite.vue";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseInput
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      model: {
        rubrica: "",
        faltasHoras: "",
        faltasDias: "",
        atrasoHoras: "",
        adNoturnoHoras: "",
        horaExtra50: "",
        horaExtra100: "",
        codEmpresa: ""
      },
      empresa: "",
      horarioSelecionado: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0
      },
      isLoading: false,
      dialogEditar: false,
      searchQuery: "",
      propsToSearch: ["name", "email", "age"],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 200
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 250
        },
        {
          prop: "age",
          label: "Age",
          minWidth: 100
        },
        {
          prop: "salary",
          label: "Salary",
          minWidth: 120
        }
      ],
      tableData: users,
      searchedData: [],
      fuseSearch: null
    };
  },
  mounted() {
    // this.notifyVue('top', 'center');
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "email"],
      threshold: 0.3
    });
  },
  methods: {
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000
      });
    },

    cadastrarRubrica() {
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        rubrica: this.model.rubrica,
        faltasHoras: this.model.faltasHoras,
        faltasDias: this.model.faltasDias,
        atrasoHoras: this.model.atrasoHoras,
        adNoturnoHoras: this.model.adNoturnoHoras,
        horaExtra50: this.model.horaExtra50,
        horaExtra100: this.model.horaExtra100,
        codEmpresa: this.model.codEmpresa
      };

      this.axios
        .post("/api/exportacao/cadastrarRubrica", bodyFormData)
        .then(() => {
          this.showSwal(
            "auto-close",
            "Sucesso",
            "Cadastrado com sucesso!",
            "success",
            true
          );
        })
        .catch(() => {
          this.showSwal(
            "auto-close",
            "Erro",
            "Ocorreu algum erro no cadastro!",
            "error"
          );
        })
        .finally(() => {
          this.isLoading = false;
          setTimeout(() => {
            this.$router.push("/exportacaoFolha");
          }, 2000);
        });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false
        });
      }
    }
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
